import React from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./PageHeader.styled";

import LoggerFrontend from "../../../../../../utils/LoggerFrontend";
import { Tooltip } from "../../../../../../Components/Overlays";

export const PageHeader = ({
  pageLogo,
  pageName,
  pageId,
  link,
  pageNameColor,
  sponsoredMessageColor,
  sponsoredLogo,
  invalidPage,
  campaignLanguage
}) => {
  const { t } = useTranslation();

  LoggerFrontend.debug("PostEditorFacebook:PageHeader:render", "renders", {
    pageId,
    campaignLanguage
  });
  return (
    <SC.PageHeaderWrapper hasError={invalidPage}>
      {link && pageId ? (
        <a
          href={`https://business.facebook.com/settings/pages/${pageId}?business_id=1775520372707006`}
          target="_blank"
          rel="noreferrer"
        >
          <SC.PageLogo src={pageLogo} alt="" />
        </a>
      ) : (
        <SC.PageLogo src={pageLogo} alt="" />
      )}
      <div>
        <SC.PageName
          color={pageNameColor}
          {...(link && pageId
            ? {
                href:
                  link && pageId
                    ? `https://business.facebook.com/settings/pages/${pageId}?business_id=1775520372707006`
                    : "",
                target: "_blank",
                rel: "noreferrer"
              }
            : {})}
        >
          {pageName}
        </SC.PageName>
        <SC.SponsoredMessage color={sponsoredMessageColor}>
          {t("Sponsored", { lng: campaignLanguage })}
          {sponsoredLogo && (
            <Tooltip label={t("Playout as sponsored advertisement")} bgColor="#1C1928">
              <SC.SponsoredLogo src="/images/sponsored_icon.svg" alt="" />
            </Tooltip>
          )}
        </SC.SponsoredMessage>
      </div>
    </SC.PageHeaderWrapper>
  );
};

export default PageHeader;
